import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getCurrentUser } from '~/features/auth/api/auth.api';

import type { PayloadAction } from '@reduxjs/toolkit';

import type { AuthUser } from '~/features/auth/types/auth.type';

export interface AuthState {
  /**
   * 세션 확인이 아직 안 끝났는지.
   * @description `authUser === null` 만으로는 "아직 확인 안 함"과 "로그인 안 함"이 구분되지 않아
   *  새로고침 직후 보호 화면이 로그인 페이지로 잠깐 튕긴다. 초기값을 true 로 두어 확인 전에는
   *  판단을 미룬다.
   */
  isLoading: boolean;
  authUser: AuthUser | null;
}

const initialState: AuthState = {
  isLoading: true,
  authUser: null,
};

/** 저장된 Supabase 세션에서 현재 사용자를 복원한다(새로고침·재방문 진입점). */
export const fetchMe = createAsyncThunk<AuthUser | null>('auth/fetchMe', async () =>
  getCurrentUser(),
);

const AuthSlice = createSlice({
  initialState,
  name: 'auth',
  reducers: {
    resetAuthUser: state => {
      state.authUser = null;
      state.isLoading = false;
    },
    /** 로그인·가입 성공 시 즉시 반영 — 세션 재조회를 기다리지 않게 한다. */
    setAuthUser: (state, action: PayloadAction<AuthUser>) => {
      state.authUser = action.payload;
      state.isLoading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchMe.pending, state => {
        state.isLoading = true;
      })
      .addCase(fetchMe.fulfilled, (state, action) => {
        state.authUser = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchMe.rejected, state => {
        state.authUser = null;
        state.isLoading = false;
      });
  },
});

export const { resetAuthUser, setAuthUser } = AuthSlice.actions;
export default AuthSlice;
